const GOOGLE_API_KEY = "AIzaSyAATDuVug8Gz29EnPl5sZbnBYz70DuZU7k";
export const GOOGLE_STATIC_MAP_API_KEY = "AIzaSyD5qrFLV0jxL8QbPzZ2zhU_XTtdfZnSJvU";

window.googleMapsLoaded = false;
window.notifyGoogleMapsLoaded = function() {
  window.googleMapsLoaded = true;
  window.dispatchEvent(new Event("googleMapsLoaded"));
};

const script = document.createElement("script");
script.src = `https://maps.googleapis.com/maps/api/js?loading=async&key=${GOOGLE_API_KEY}&libraries=places,marker&callback=notifyGoogleMapsLoaded&v=weekly`;
script.async = true;
script.defer = true;
document.body.appendChild(script);